import { BehaviorSubject } from 'rxjs'
import MySquid from '@interfaces/my-squid.interface'
export default new BehaviorSubject<MySquid | boolean>(false)
